import React, { useRef } from "react";

import classes from "../Login.module.scss";
import RoundedButton from "../../Buttons/RoundedButton";
import TagInput from "../../UI/Inputs/TagInput";
import H1 from "../../UI/Titles/H1/h1";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import * as kApi from "../../../constants/api";

const InitResetPWForm = ({
  login = {},
  errorMsg = null,
  formSubmit = () => { },
  onChange = () => { },
  bottomLink = () => { },
}) => {
  const { t } = useTranslation();
  const recaptchaRef = useRef(null);
  const onExpireRecaptcha = (e) => {
    console.log("onExpireRecaptcha", e)
    recaptchaRef.current.execute();
  }
  const onErrorRecaptcha = (e) => {
    console.log("onExpireRecaptcha", e)
  }
  const onRecaptchaCorrect = (e) => {
    console.log("onRecaptchaCorrect")
    formSubmit();
  }
  return (
    <>
      <form className={classes.Form} onSubmit={(event) => {
        if (event) event.preventDefault();
        recaptchaRef.current.execute();
      }}>
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={kApi.SECRET_reCAPTCHA}
          isolated={true}
          badge="bottomleft"
          type="image"
          onErrored={onErrorRecaptcha}
          onChange={onRecaptchaCorrect}
          onExpired={onExpireRecaptcha}
        />
        <H1 className={classes.Title}>{t("login.reset_password")}</H1>
        {errorMsg && <div className={classes.ErrorMsg}>{t(errorMsg)}</div>}
        <TagInput
          type="email"
          name="username"
          className={classes.Input}
          placeholder={"email"}
          value={login.username}
          onChange={onChange}
          required
        />
        <p>
          <em>{t("login.verification_code")}</em>
        </p>
        <RoundedButton
          className={classes.BtnEnter}
          type="submit"
          text={t("login.confirmation")}
        />
        <button
          tabIndex="0"
          className={classes.TextInfo + " link"}
          onClick={() => bottomLink()}
        >
          {t("login.back_to_login")}
        </button>
      </form>
    </>
  );
};

export default InitResetPWForm;
